var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content)?_c('div',{staticClass:"pro-age"},[_c('div',{staticClass:"pro-age__wrapper"},[_c('ProAgeBanner'),_c('ProAgeEvent'),_c('ProAgePractice'),_c('ProAgeProgram'),_c('ProAgeWhatYouGet'),_c('ProAgeFormat'),_c('ProAgeImage'),_c('ProAgeEvents'),_c('ProAgeList')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }